import { AolGroup } from '../../types/ViewModel/AolItem';
import { getDateFromFormat, formatDateTime, DateTimeFormat } from 'odfjell-date-time-utils/dateTimeFormatter';
import { getDateFromISO } from 'odfjell-date-time-utils/dateTimeUtils';


export const getAolGroupDate = (aolGroup: AolGroup) => getDateFromFormat(aolGroup.aolDate, DateTimeFormat.queryFormats.dateOnly);
export const getAolDateLocalTime = (date: string) => getDateFromFormat(date, DateTimeFormat.queryFormats.dateOnly);

export const getAolDateFromUrlFormat = (date: string) => getDateFromFormat(date, DateTimeFormat.urlFormats.dateOnly);
export const getAolFromToTimeFromUrlFormat = (date: string) => getDateFromISO(date);

export const formatAolGroupDate = (date: Date) => formatDateTime(date, DateTimeFormat.queryFormats.dateOnly);
export const formatAolUrlDate = (date: Date) => formatDateTime(date, DateTimeFormat.urlFormats.dateOnly);
export const formatAolFromToTimeUrl = (date: Date) => `${formatDateTime(date, DateTimeFormat.urlFormats.URLDateTime)}`;

export const formatQueryDateOnly = (date: Date) => formatDateTime(date, DateTimeFormat.queryFormats.dateOnly);

// A date that has no AOL group in any tab is a day that is not displayed (a westward date-line crossing date, or a date outside the loaded range).
// It resolves to the nearest retained day of the given list: the day before it, else the oldest retained day (so a hidden date older than every
// retained group selects the oldest, and one newer than every retained group selects the newest). Undefined for a displayed date or when no
// group is retained. A resolved day is displayed, so resolving it again returns undefined (no redirect loop).
export const findNearestAolGroupForHiddenDate = (candidateGroups: AolGroup[], allGroups: AolGroup[], date: Date): AolGroup | undefined => {
    const day = formatAolGroupDate(date);
    if (allGroups.some((g) => g.aolDate === day)) return undefined;
    const sorted = [...candidateGroups].sort((a, b) => (a.aolDate < b.aolDate ? -1 : 1));
    const before = sorted.filter((g) => g.aolDate < day);
    return before.length > 0 ? before[before.length - 1] : sorted[0];
};
